import { IUserProfile } from "../Types/UserProfileTypes";

/**
 * Fetches logged in user profile.
 * @param token oidc access token.
 */
async function getUserProfileData(
  token: string
): Promise<IUserProfile> {
  const url = `${import.meta.env.VITE_DATA_API}/api/userprofile`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return await response.json();
}

export { getUserProfileData };
